import {Component, ElementRef, EventEmitter, forwardRef, Input, Output, Renderer2} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {isNil} from 'lodash-es';


@Component({
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColorPickerComponent),
            multi: true
        },
    ],
    standalone: false
})
export class ColorPickerComponent implements ControlValueAccessor {
  isNil = isNil;
  colors: string[] = [];
  color: string;
  dirty = false;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() required: boolean;
  _exceptedColors: string[] = [];

  @Input() set exceptedColors(value: string[]) {
    this._exceptedColors = value;
    this.colors = this.defaultColors.filter(item => this._exceptedColors.indexOf(item) < 0);
  }

  public show = false;
  public defaultColors: string[] = [
    'eb6060',
    'CF0C0C',
    'f7e463',
    'E9D867',
    '0572ee',
    '0D94E7',
    'a8a8a8',
    '949494',
    'f38609',
    'EBA447',
    '000000',
    'E70DB8',
    '7cd992',
    '48E70D',
    '053FB3',
    '585B5F',
    '65C2E2',
    'EDE607'
  ];

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
    ) {
      this.colors = this.defaultColors;
  }

  /**
   * Change color from default colors
   * @param {string} color
   */
  public changeColor(color: string): void {
    this.color = color;
    this.valueChange.emit(this.color);
    this.show = false;
  }

  /**
   * Change status of visibility to color picker
   */
  public toggleColors(): void {
    this.show = !this.show;
  }

  writeValue(value) {
    if (value) {
      this.color = value;
    }
  }

  onChange: any = () => {
  }

  onTouched: any = () => {
    this.dirty = true;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  showError(): boolean {
    return this.required && this.dirty && isNil(this.color);
  }
}
